import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { skillListConstant } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE,
  GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST,
  GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS,
} = skillListConstant;

function* getSkillListScheduling(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistSchedulingServices.getSkillListScheduling, action.payload);
    if (response?.status === 200) {
      yield put({
        type: GET_SKILL_THERAPIST_SCHEDULING_LIST_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SKILL_THERAPIST_SCHEDULING_LIST_FAILURE, payload: error });
  }
}

function* getSkillListSchedulingSaga() {
  yield takeEvery(GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST, getSkillListScheduling);
}

export default getSkillListSchedulingSaga;
